/**
 * `graphql-field-type` are a duplicate of `graphql-field-types` from `@atlassian/jira-issue-create`
 * located in src/packages/issue-create/issue-create-modal/src/common/constants/graphql-field-types.tsx
 * This was done to prevent cyclic dependencies between packages.
 * Only field types the UIM currently support or plan to support were taken from the referenced file.
 */

// graphql __typename
export const ISSUE_TYPE_FIELD = 'JiraIssueTypeField';
export const TEXT_FIELD = 'JiraSingleLineTextField';
export const RICH_TEXT_FIELD = 'JiraRichTextField';
export const COMPONENTS_FIELD = 'JiraComponentsField';
export const USER_PICKER_FIELD = 'JiraSingleSelectUserPickerField';
export const MULTI_USER_PICKER_FIELD = 'JiraMultipleSelectUserPickerField';
export const PEOPLE_FIELD = 'JiraPeopleField';
export const LABEL_FIELD = 'JiraLabelsField';
export const PRIORITY_FIELD = 'JiraPriorityField';
export const DATE_PICKER_FIELD = 'JiraDatePickerField';
export const URL_FIELD = 'JiraUrlField';
export const CHECKBOX_FIELD = 'JiraCheckboxesField';
export const RADIO_FIELD = 'JiraRadioSelectField';
export const SINGLE_SELECT_FIELD = 'JiraSingleSelectField';
export const MULTI_SELECT_FIELD = 'JiraMultipleSelectField';

// type overrides (these are some types that we have created on FE side to handle fields with special behaviour)
export const ASSIGNEE_FIELD = 'JiraAssigneeField';
export const REPORTER_FIELD = 'JiraReporterField';
export const TEXT_AREA_FIELD = 'JiraTextAreaField';
